import React from "react";
import HandleStyleRadioGroup from "./HandleStyleRadioGroup";
import { cn } from "../../../../lib/utils";
import { handles } from "../../../../lib/constant";
import ExternalHandleSizes from "./ExternalHandleSizes";

const HandleStyle = ({ methods, isOpen: { HandleStyle } }) => {
    return (
        <div
            className={cn(
                "section grid grid-cols-4 transition-all opacity-0 h-0 ",
                {
                    ["h-full opacity-100"]: HandleStyle.isOpen,
                }
            )}
        >
            <HandleStyleRadioGroup
                path="external"
                handles={handles}
                {...methods}
            />
            <ExternalHandleSizes {...methods}/>
        </div>
    );
};

export default HandleStyle;
